package ru.villawonka.app.domain.model

enum class AccommodationAdditionDomain {
    NEAR_GYM,
    NEAR_BEACH,
    NEAR_CAFE,
    TV,
    WIFI,
    WASHING_MACHINE,
    SAFE,
    JACUZZI,
    AIR_CONDITION,
    TERRACE,
    VIDEO_SURVEILLANCE,
    BARBECUE_AREA,
    POOL,
    PARKING,
    CLEANING,
    CLOSED_KITCHEN,
    CLOSED_LIVING_ROOM,
    UTILITY_BILLS_INCLUDED,
    DRINK_WATER_INCLUDED,
    HAS_DISCOUNT,
}